
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SMUser } from "@/store";
import Banner from "@/components/V2/Banner/Banner.vue";
import {
  EMPLOYEE_LESS_THAN_4_MONTHS,
  EMPLOYEE_EXPIRED,
  EMPLOYEE_EXPIRED_LESS_THAN_4_MONTHS,
} from "@/constants/banner";

@Component({
  components: { Banner },
})
export default class BannersSection extends Vue {
  @Prop({ type: String, default: null }) readonly type: string;

  emitBannerAction(payload) {
    payload?.action?.();
  }

  banners = [];

  calculateBanners() {
    this.banners = [];

    // Compliance Blocked
    if (SMUser.isComplianceBlocked) {
      this.banners.push(EMPLOYEE_EXPIRED);
      this.banners.push(EMPLOYEE_EXPIRED_LESS_THAN_4_MONTHS);

      return;
    }

    // is SL confitmed
    if (SMUser.isSponsorConfirmed) {
      this.banners.push(EMPLOYEE_LESS_THAN_4_MONTHS);

      return;
    }
  }

  get user() {
    return SMUser.user;
  }

  @Watch("user", { immediate: true, deep: true })
  isUserChanged() {
    this.calculateBanners();
  }

  mounted() {
    this.calculateBanners();
  }
}
